<div class="search-users-input tui-space_bottom-4">
  <tui-textfield
    *ngIf="mode === 'single'"
    tuiChevron
    [tuiDropdownMobile]="title"
    [stringify]="stringify"
    [identityMatcher]="matcher"
    [tuiTextfieldCleaner]="true"
    [tuiTextfieldSize]="textfieldSize"
    (click)="isMobile ? onSearchUsers() : undefined"
  >
    <label tuiLabel>{{ title }}</label>

    <input
      tuiSelect
      [disabled]="disabled"
      [invalid]="touched && invalid"
      [ngModel]="getValue()"
      (ngModelChange)="setValue($event)"
    />

    <ng-container *ngIf="!isMobile">
      <ng-container *tuiTextfieldDropdown>
        <app-search class="search" (searchQueryChange)="onSearchChange($event)"></app-search>

        <tui-data-list [size]="'l'">
          <button *ngFor="let item of filteredItems$ | async" new tuiOption type="button" [value]="item">
            <render-user-row [user]="item" [statusContent]="statusContent"></render-user-row>
          </button>
        </tui-data-list>
      </ng-container>
    </ng-container>
  </tui-textfield>

  <tui-textfield
    *ngIf="mode === 'multiple'"
    multi
    tuiChevron
    tuiDropdownMobile
    [rows]="3"
    [stringify]="stringify"
    [identityMatcher]="matcher"
    [tuiTextfieldCleaner]="true"
    [tuiTextfieldSize]="textfieldSize"
    [open]="dropdownOpen"
    (openChange)="isMobile ? undefined : setDropdownOpen($event)"
    (click)="isMobile ? onSearchUsers() : undefined"
  >
    <label tuiLabel>{{ title }}</label>

    <input tuiInputChip tuiSelectLike [disabled]="disabled" [invalid]="touched && invalid" [(ngModel)]="value" />

    <ng-container *ngIf="!isMobile">
      <ng-container *tuiTextfieldDropdown>
        <app-search class="search" (searchQueryChange)="onSearchChange($event)"></app-search>

        <tui-data-list [size]="'l'">
          <tui-opt-group tuiMultiSelectGroup [label]="'common.labels.selectAll' | translate">
            <button
              *ngFor="let item of filteredItems$ | async"
              new
              tuiOption
              type="button"
              [tuiTextfieldSize]="'l'"
              [value]="item"
            >
              <render-user-row [user]="item" [statusContent]="statusContent"></render-user-row>
            </button>
          </tui-opt-group>

          <button appearance="primary" size="m" tuiButton tuiDropdownButton (click)="setDropdownOpen(false)">
            {{ 'common.buttons.ready' | translate }}
          </button>
        </tui-data-list>
      </ng-container>
    </ng-container>
  </tui-textfield>

  <div *ngIf="showFilterButton && !isMobile" tuiGroup class="search-users-input__actions" [collapsed]="true">
    <button
      tuiButton
      type="button"
      appearance="outline-grayscale"
      tuiAppearanceMode="checked"
      size="m"
      [disabled]="disabled"
      (click)="onSearchUsers()"
    >
      {{ filterButtonText }}
    </button>

    <button
      tuiIconButton
      class="tui-group__auto-width-item"
      type="button"
      appearance="outline-grayscale"
      tuiAppearanceMode="checked"
      iconStart="@tui.circle-plus"
      size="m"
      [disabled]="disabled"
      (click)="onSearchUsers()"
    ></button>
  </div>
</div>
